import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { ROUTES } from '../../server-route';
import { Observable } from 'rxjs/internal/Observable';
import { Route } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class PointToContactService extends ApiService {

  public getPOCDetails(): Observable<any>{
    
    return this.get<any>(`${ROUTES.POINT_OF_CONTACT_URL}`)
  }

}
